import * as React from "react";
const SvgBuilding04 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.965 6.2c0-.577 0-.948-.024-1.23-.022-.269-.06-.365-.082-.408a.97.97 0 0 0-.42-.421c-.044-.023-.14-.06-.41-.082-.281-.023-.652-.024-1.23-.024H9.2c-.577 0-.948 0-1.23.024-.269.022-.365.06-.408.082a.97.97 0 0 0-.421.42c-.023.044-.06.14-.082.41-.023.281-.024.652-.024 1.23v13.764h9.93zM14.5 13.965a1.035 1.035 0 0 1 0 2.07h-5a1.035 1.035 0 0 1 0-2.07zm0-4a1.035 1.035 0 0 1 0 2.07h-5a1.035 1.035 0 0 1 0-2.07zm0-4a1.035 1.035 0 0 1 0 2.07h-5a1.035 1.035 0 0 1 0-2.07zm4.535 14H20a1.035 1.035 0 0 1 0 2.07H4a1.035 1.035 0 0 1 0-2.07h.965V6.2c0-.543 0-1.013.031-1.398.033-.398.104-.796.3-1.18a3.04 3.04 0 0 1 1.326-1.326c.384-.196.782-.267 1.18-.3.385-.031.855-.031 1.398-.031h5.6c.543 0 1.013 0 1.398.031.398.033.796.104 1.18.3a3.04 3.04 0 0 1 1.326 1.326c.196.384.267.782.3 1.18.031.385.031.855.031 1.398z"
}));
export default SvgBuilding04;
//# sourceMappingURL=Building04.js.map